import { useNavigate } from "react-router-dom";
import useAppState from "../../context/AppContext";
import { APP_RETIREMENT_URLS, APP_URLS } from "../../const/AppConst";
import { handleKeyDown } from "../../utils/utils";



export default function PostSignatureActionFormComponent() {

    const navigate = useNavigate();
  
    const {
      state: { proposition, isRetired },
      
    } = useAppState();

    return (
        <form>
          <div className="flex bg-blanc shadow-noir p-md va-center m-y-lg hover-opacity" onClick={() => navigate(isRetired ? APP_RETIREMENT_URLS.retirementRecapPage : APP_URLS.recapPage)} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>
            <p style={{flex: 1}} className="card-title bleu">Récapitulatif</p>
            <i className="icon-chevron-right bleu"></i>
          </div>
          {
            proposition?.configuration.hasSignature &&
            <div className="flex bg-blanc shadow-noir p-md m-sm-desktop va-center m-y-lg hover-opacity" onClick={() => navigate(isRetired ? APP_RETIREMENT_URLS.infoSignatureDonePage : APP_URLS.infoSignatureStep2Page)} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>
              <p style={{flex: 1}} className="card-title bleu">Documents signés</p>
              <i className="icon-chevron-right bleu"></i>
            </div>
          }
          <div className="flex bg-blanc shadow-noir p-md m-sm-desktop va-center m-y-lg hover-opacity" onClick={() => navigate(isRetired ? APP_RETIREMENT_URLS.listInvalidDocumentPage : APP_URLS.listInvalidDocumentPage)} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>
            <p style={{flex: 1}} className="card-title bleu">Justificatifs</p>
            <i className="icon-chevron-right bleu"></i>
          </div>
          <div className="flex bg-blanc shadow-noir p-md m-sm-desktop va-center m-y-lg hover-opacity" onClick={() => navigate(isRetired ? APP_RETIREMENT_URLS.infoModificationPage : APP_URLS.infoModificationPage)} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>
            <p style={{flex: 1}} className="card-title bleu">Correctif des informations</p>
            <i className="icon-chevron-right bleu"></i>
          </div>
        </form>
    );

}